import { HMIS_USERNAME } from "@/plugins/vars";

export const checkAuth = function () {

    const user = window.Cookies.get(HMIS_USERNAME);

    return user ? true : false;
}

export const user = function () {

    const user = window.Cookies.get(HMIS_USERNAME);

    return user ? user : "";
}

export const checkRight  = function (params) {

    const permissions = window.JSON.parse(window.localStorage.getItem('P_102')) || [];

    const filtered = permissions.filter(permission => permission.name == params.PageName);
 //var activityname='User Login: Successfuly Logged In'+params.PageName;
        //this.$root.RecordUserActivity(HMIS_USERNAME,activityname);
      
    return new Promise((resolve, reject) => {

        if(!filtered.length) {
            reject(() => {});
            return;
        }
        //var activityname='User Login: Successfuly Logged In'+params.PageName;
        //this.$root.RecordUserActivity(HMIS_USERNAME,activityname);
           
        resolve(() => {
          
        });
        var activityname='User Login: Successfuly asas'+params.PageName;
        this.$root.RecordUserActivity(HMIS_USERNAME,activityname);
         
    });
}

export const resetAutoLogoutTimer = () => {

    window.Cookies.set('logOutAt', window.moment().add(20, 'minutes').format());
}

export const checkInactiveTimeOut = () => {

    if(window.moment() > window.moment(window.Cookies.get('logOutAt'))) {
        window.Cookies.remove(HMIS_USERNAME);
        window.Cookies.remove("P_102");
        window.localStorage.removeItem("P_102");
        window.location.replace('/login');
    }
}

